import { render } from "./PopupApprouve.vue?vue&type=template&id=1f7a30d7"
import script from "./PopupApprouve.vue?vue&type=script&lang=js"
export * from "./PopupApprouve.vue?vue&type=script&lang=js"

import "./PopupApprouve.vue?vue&type=style&index=0&id=1f7a30d7&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__